<template>
  <div class="main-wrapper">
    <header-new :title="gameDetail.title" :return_id="gameDetail.return_id" :apiKey="key" page="history"></header-new>
    <section class="nft-activity-area pt-120 pb-120 position-relative overflow-hidden">
      <img :src="require('../assets/images/shapes/hero-top-left.svg')" alt="shape" class="shape-top-left position-absolute">
      <div class="container">
        <div class="row">
          <h3>Ödeme Geçmişi</h3>
          <div class="col-lg-12">
            <div class="ctp-tab">
              <ul class="nav nav-tabs">
                <li>
                  <button  type="button" :class="{'active' : tab === 1}" @click="tab = 1">Tüm Ödemeler</button>
                </li>
                <li>
                  <button  type="button" :class="{'active' : tab === 2}" @click="tab = 2">Başarılı </button>
                </li>
                <li>
                  <button  type="button" :class="{'active' : tab === 4}" @click="tab = 4">İptal Edilen </button>
                </li>
              </ul>

            </div>

            <div class="activity-list">
              <div class="table-responsive">
                <table class="table table-striped table-bordered align-middle">
                  <thead>
                  <tr>
                    <th>Ödeme Yöntemi</th>
                    <th>Tutar</th>
                    <th>Ödeme Durumu</th>
                    <th>Tarih</th>
                  </tr>
                  </thead>
                  <tbody v-if="loading">
                    <tr v-for="(index) in 1" :key="index">
                    <td class="item-info d-flex align-items-center" >
                      <h6 v-if="index === 1"><i class="fas fa-spinner fa-spin text-info"></i></h6>
                    </td>
                    <td class=" ">
                      <h6 v-if="index === 1"><i class="fas fa-spinner fa-spin text-info"></i></h6>
                    </td>
                    <td>
                      <h6 v-if="index === 1"><i class="fas fa-spinner fa-spin text-info"></i></h6>

                    </td>
                    <td>
                      <h6 v-if="index === 1"><i class="fas fa-spinner fa-spin text-info"></i></h6>

                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else>
                  <tr v-if="!orders">
                    <td class="text-danger"> Kayıt bulunamadı. </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr v-for="(item, index) in orders" :key="index">
                    <td class="item-info d-flex align-items-center" >
                      <h6>{{ item.payment.title }}</h6>
                    </td>
                    <td class=" ">
                      <div class="item-content ms-3"><span>Tutar</span>
                        <h6>{{ item.price | currency }} TL</h6>
                      </div>
                    </td>
                    <td>
                      <span class="text-success"  v-if="item.status === '1'"> <i class="fas fa-check-circle"></i> Ödeme Başarılı.</span>
                      <span class="text-danger" v-if="item.status === '2'"> <i class="fas fa-cancel"></i> Ödeme Başarısız.</span>
                      <span class="text-info" v-if="item.status === '0'"> <i class="fas fa-spinner fa-spin"></i> Ödeme Bekleniyor.</span>
                    </td>
                    <td>
                      <div class="time text-center"><span>{{ item.date | formatDate }}</span></div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img :src="require('../assets/images/shapes/hero-top-right.svg')" alt="shape" class="shape-right-top position-absolute">
      <img :src="require('../assets/images/shapes/hero-top-right.svg')" alt="shape" class="right-0 shape-bottom position-absolute">
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import apiService from "@/services/apiService";
import HeaderNew from "@/components/HeaderNew";
import Footer from "@/components/Footer";
export default {
  name: "Home",
  data() {
    return {
      key: this.$route.params.key,
      keyErr : false,
      gameDetail: {
        title: '',
        products: [],
      },
      loading: true,
      orders: [],
      tab: 1,
      status: ''

    }
  },
  components: { HeaderNew, Footer },
  methods: {
    successMessage(val) {
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: val,
        text: '',
      });
    },
    errorMessage(val) {
      this.$swal({
        showConfirmButton: true,
        icon: 'error',
        title: 'HATA',
        text: val,
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });
    },
    checkKey() {
      apiService.checkPaymentLink({key: this.key})
          .then((res) => {
            if(res.state) {
              this.keyErr = false
            }
            else {
              this.errorMessage(res.message)
              this.keyErr = true
            }
          })
    },
    gameDetails() {
      apiService.gameDetail({key: this.key})
          .then((res) => {
            if(res.state){
              this.gameDetail = res.data
              this.getOrders()
            }else{
              this.errorMessage(res.message)
              this.keyErr = true
            }
          })
    },
    getOrders() {
      this.loading = true
      this.orders = []
      apiService.getHistory({key: this.key, status: this.status})
      .then((res) => {
        if(res.state){
          this.orders = res.data
          this.loading = false
        }else{
          this.errorMessage(res.message)
          setTimeout(() => {
            this.$router.push({path : '/'+this.key })
          }, 1500)
        }
      })
    }
  },
  created() {
    this.key = this.$route.params.key
    this.checkKey()
    this.getOrders()
  },
  watch: {
    keyErr : function () {
      if(this.keyErr)
        setTimeout(() => {
          window.location.href = 'https://kasagame.com'
        }, 1500)
    },
    tab: function () {
      if(this.tab === 1){
        this.status = ''
      }else if(this.tab === 2)
        this.status = '1'
      else if(this.tab === 3)
        this.status = '0'
      else if(this.tab === 4)
        this.status = '2'
      this.getOrders()
    }
  }
}
</script>

<style scoped>

</style>